
<template>
    <div v-if="showModel" class="edit-model">
        <div class="img-div">
            <div>{{title}}</div>
            <div class="close-img" @click="cancel"><i class="iconfont">&#xe641;</i></div>
        </div>
       
        <Form ref="formData" :model="formData" :rules="ruleCustom" :label-width="80">
            <FormItem label="积分规则" prop="describe" class="ivu-form-item-required">
                <NEditor
                    ref="nediter"
                    @setDetail="setSelected($event,'describe')"
                    :value="formData.describe"
                ></NEditor>
            </FormItem>
            <FormItem>
                <Button :disabled="disabled" type="primary" @click="subData('formData')">确定</Button>
            </FormItem>
            
        </Form>
    </div>
</template>
<script>
/**
 * 弹框
 * @param showModel boolean 对话框开关 true false
 * @param fn function 回调函数
 * @param type Number 类型 1添加 2编辑
 * @param editFormData Object 编辑时的数据
 */
import common from "@/common/common";
import NEditor from "@/views/common/neditor.vue";
export default {
  props: {
    showModel: Boolean,
    fn: Function,
    type: Number,
    editFormData: Object
  },
  name: "Model1",
  components: {
      NEditor
  },
  data() {
    return {
      //上传图片 start
      action: this.config.urlArray.goodUploadThumb, //上传图片接口
      num: 1, //图片上传数量
      hasUpload: [], //已上传图片
      //上传图片 end
      tabIndex:'1',
      title: "积分规则",
      disabled: false,
      formData: {
        describe:""
      },
      ruleCustom: {
      }
    };
  },
  created(){
  },
  watch: {
    showModel(val) {
      if (val) {
        this.getData()
      }
    }
  },
  methods: {
    setSelected(data, key) {
      this.formData[key] = data;
    },
    getData(){ //获取数据
        let getData = { }
        this.axios.get(this.config.urlArray.integralConfigDetail,getData).then((result) => {
            common.ajaxMsg(result.data);
            console.log('22',result.data.data)
            let ss = result.data.data
            this.formData.describe = ss.describe || ""
            this.$refs.nediter.setEditer(this.formData.describe);
           
    }).catch((err) => {
        common.msg('error','获取失败',()=>{})
    });
    },
    subData(name) {
      //提交表单
      this.$refs[name].validate(valid => {
        if (valid) {
          this.disabled = true;
          this.axios
            .post(this.config.urlArray.integralConfigStore, this.formData)
            .then(result => {
              common.ajaxMsg(
                result.data,
                true,
                () => {
                  //提交表单后的回调处理
                  this.resetForm(); //重置表单
                  this.fn();
                },
                () => {
                  this.disabled = false;
                }
              );
            })
            .catch(err => {
              common.msg("error", "提交失败", () => {
                this.disabled = false;
              });
            });
        }
      });
    },
    cancel() {
      //对话框关闭
      this.$emit("update:showModel", false);
      this.resetForm();
      this.fn();
    },
    setThumbUrl(url) {
      //获取图片上传后的路径
      this.formData.thumb = url;
    },
    resetForm() {
      this.formData = this.defaultData;
      //重置表单
      this.$refs.formData.resetFields(); //重置表单
      this.disabled = false; //恢复提交按钮为激活状态
      this.tabIndex = '1'
    }
  }
};
</script>
<style lang='scss' scoped>
.edit-model {
  position: relative;
  .img-div {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 45px;
    div {
      font-weight: bold;
      font-size: 15px;
    }
  }
  .close-img {
    border: 1px solid #fd6363;
    display: inline-block;
    line-height: 100%;
    border-radius: 100%;
    padding: 5px;
    color: #f00;
    right: 10px;
    top: 10px;
    z-index: 3;
    cursor: pointer;
  }
  .close-img:hover {
    transform: scale(1.1);
    transition: all 0.3s;
  }
}
</style>